import { Flex, Text } from "@chakra-ui/react"
import { MobilePhone } from "./MobilePhone"
import { EmailAddress } from "./EmailAddress"

export const Contact = ({ name, phone, mobilePhone, email }: { name: string, phone?: string, mobilePhone?: string, email?: string }) => {
    return (
        <Flex sx={{ flexWrap: 'wrap', flexDirection: 'column', gap: 1 }}>
            <Text sx={{ my: 1, color: 'primary.500', fontWeight: 'medium' }}>{name}</Text>
            {phone && <MobilePhone mobilePhone={phone} />}
            {mobilePhone && <MobilePhone mobilePhone={mobilePhone} />}
            {email && <EmailAddress email={email} />}
        </Flex>
    )
}